import * as types from "../constants/actionTypes";

export const myChartDataTileInitialState = {
    touched: false
};

export default function myChartDataTileReducer(state = myChartDataTileInitialState, action) {
    switch (action.type) {
        case types.MYCHART_DATA_TILE_TOUCHED_SUCCESS:
            console.info(`myChartDataTileReducer`,action);
            return { ...state,touched:action.data.data.touched };
        default:
            return { ...state };
    }
}